import { Controller } from "@hotwired/stimulus"

// Controller for showing/hiding the inline task form on project show page
export default class extends Controller {
  static targets = ["trigger", "form"]

  show(event) {
    event.preventDefault()
    this.triggerTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    // Focus the title input
    const titleInput = this.formTarget.querySelector("input[type='text']")
    if (titleInput) titleInput.focus()
  }

  hide(event) {
    if (event) event.preventDefault()
    this.formTarget.classList.add("hidden")
    this.triggerTarget.classList.remove("hidden")
  }
}
